import { render } from "./FpuiInputHidden.vue?vue&type=template&id=4fbf3d04&lang=pug"
import script from "./FpuiInputHidden.vue?vue&type=script&lang=js"
export * from "./FpuiInputHidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__